<!------------------------------------------------------------------------------
 File: PagesManager 
 Created by keni.
 with: IntelliJ IDEA
 Date: 02/05/2018
 Time: 11:59
------------------------------------------------------------------------------->
<template>
    <div class="card-body">
        <div class="">
            <div class="row">
                <!--item description-->
                <div class="col-12 col-md-8">
                    <h5 class="card-title">{{title}}</h5>
                    <p class="card-text" v-html="description"></p>
                </div>
                <!--hide show the save button-->
                <div class="col-12 col-md-4">
                    <transition name="fade">
                        <div v-if="changed_data_set"
                                class=" d-flex justify-content-end align-items-center "
                        >
                            <div class="btn btn-secondary" v-on:click="save()">
                                <i class="material-icons">save</i>
                            </div>
                        </div>
                    </transition>
                </div>
            </div>
        </div>
        <div class="">
            <ul class="list-group list-group-flush">
                <!--list the item-->
                <li class="list-group-item"
                        v-for="module,index in selected_modules"
                        v-on:click="setActive(module,index)"
                        :class="{
                    'bg-secondary text-white':isActive(module,index) && index !== 'category_list',
                    'cursor-pointer':index !== 'category_list'
                }"
                >
                    <div class="text-capitalize">{{module.title}}</div>
                    <!--{{log(module)}}-->
                    <div class="w-100"
                            v-if="hasOwnNestedProperty(module,'params.filter') && module.params.filter != null"
                    >
                        <!--{{log(module.params.filter)}}-->
                        <div class="row" v-if="module.params.filter == 'category'">
                            <div
                                    v-for="category in categories"
                                    class="col form-check"
                            >
                                <input type="checkbox"
                                        :name="`${module_set}->modules->${index}->selects->${category.id}`"
                                        class="form-check-input"
                                        :class="index"
                                        :id="`${index}--${category.slug}`"
                                        v-on:click="categorySelected(category, index)"
                                        :checked="(isCategorySelected(category,index))?true:false"
                                >
                                <label class="form-check-label"
                                        :for="`${index}--${category.slug}`"
                                >
                                    {{lang('title',category.category_data.lang)}}
                                </label>

                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
	import {_} from 'underscore';
	import {hasOwnNestedProperty} from '../../../../../app/Shared/Resources/Assets/js/helpers/object.formats';
	import lang from '../../../../../app/Shared/Resources/Assets/js/helpers/lang';

	export default {
		name: "pages-manager",
		components: {},
		props: ['selected_modules', 'title', 'description', 'auth', 'config', 'module_set', 'save_route_uri', 'read_route_uri', 'categories_route_uri'],
		created() {
			this.data_set = this.config;
			// console.log('this.selected_modules', this.selected_modules);

		},
		destroyed() {
		},
		mounted() {
			// console.log('this.selected_modules', this.selected_modules, 'config', this.config);
			this.categoryChooser();
		},
		data() {
			return {
				data_set: {},
				changed_data_set: false,
				categories: []
			}
		},
		methods: {

			lang(path, object) {
				return lang(path, object);
			},
			log(x) {
				console.log('x', x);
			},
			hasOwnNestedProperty(obj, propertyPath) {

				// console.error('has', propertyPath,has,(has)?obj[propertyPath]:false);
				return hasOwnNestedProperty(obj, propertyPath);
			},
			setActive(module, module_item) {
				this.createDataReference(module_item);
				this.data_set[this.module_set].modules[module_item].active = !this.data_set[this.module_set].modules[module_item].active;
				let has = this.hasOwnNestedProperty(module, 'params.filter');

				if (has && module.params.filter != null) {
					return false;
				}
				this.changed_data_set = true;

				return this.data_set[this.module_set].modules[module_item].active;
			},
			isActive(module, module_item) {
				// console.log('isActive->this.module_set', this.module_set, 'module', module, 'module_item', module_item);
				// make sure current page is there
				if (!this.module_set in this.data_set) {
					console.error('no set', this.module_set);
					return false;
				}

				// get the current page modules
				let pageModule = this.isset(module_item),
					result = false;
				// console.log('property',property);
				// console.log('thePageReference', thePageReference);
				// console.log('this.data_set', this.data_set);
				// if (thePageReference == null) {
				// 	return false;
				// }
				if (typeof pageModule !== 'undefined' && pageModule !== null) {
					if (typeof pageModule.active !== 'undefined' && pageModule.active !== null) {
					}
					else {

						pageModule['active'] = false;

					}
					result = pageModule.active;
				}
				else {
					result = false;
				}
				// console.log('thePageReference',pageModule, 'thePageReference.active',pageModule.active);
				return result;
			},
			createDataReference(module_item) {
				//check if page reference exists
				if (this.module_set in this.data_set === false) {
					this.data_set[this.module_set] = {
						modules: {}
					};
					console.error('data set for page not present.creating', this.data_set[this.module_set]);
				}
				if (!module_item in this.data_set[this.module_set]) {
					this.data_set[this.module_set].modules[module_item]['active'] = false;
					this.data_set[this.module_set].modules[module_item]['value'] = false;
				}

				// console.log('this.data_set[this.module_set][property]',this.data_set[this.module_set][property]);
				return this.data_set[this.module_set].modules[module_item];
			},
			/**
			 * Adds or removes from saved config
			 * @param category
			 * @param element
			 */
			categorySelected(category, element) {
				// console.log('categorySelected', 'category', category, 'element', element);
				this.createDataReference(element);
				//define the array if not there already
				this.data_set[this.module_set].modules[element].selects = this.data_set[this.module_set].modules[element].selects || [];
				//
				// // set the category id
				let id = category.id;
				let state = '';
				// id will be stored in the selects reference as array element
				// selects = [1,2,3,4,5]

				// does record exist?
				// console.log('categorySelected', 'this.data_set',this.data_set[this.module_set]);
				//
				let found_category_id = _.find(this.data_set[this.module_set].modules[element].selects, function (num) {
					return (num == id);
				});
				console.log('categorySelected', 'found',found_category_id);
				// console.log('categorySelected', 'id',id);
				//
				if (!(typeof found_category_id !== 'undefined' && found_category_id !== null)) {
					// console.log('categorySelected', 'this.data_set[this.module_set].modules[element]',this.data_set[this.module_set].modules[element].selects);
					this.data_set[this.module_set].modules[element].selects.push(id);
					//console.log('categorySelected', 'this.data_set[this.module_set].modules[element].selects', this.data_set[this.module_set].modules[element].selects);
					state = 'checked';
				}
				else {
					//it was found so remove it
					// console.log('categorySelected', element, this.module_set, 'this.data_set[this.module_set][element]', this.data_set[this.module_set].modules[element]);
let elementDetails = this.data_set[this.module_set].modules[element];
// console.error('elementDetails',elementDetails);
					this.data_set[this.module_set].modules[element].selects = _.reject(elementDetails.selects, function (num) {
						return num == id;
					});
				}
				this.changed_data_set = true;
				return state;

			},
			isCategorySelected(category, module_name) {
				let id = category.id;
				// console.log('isCategorySelected', 'property', module_name);
				let thePageReference = this.isset(module_name);
				// console.log('isCategorySelected', 'thePageReference', thePageReference);
				if (!'selects' in thePageReference) {
					return false;
				}
				if (_.indexOf(thePageReference.selects, id) > -1) {
					return true;
				}

				// if (thePageReference == null) {
				// 	return false;
				// }
				// let testIds = thePageReference.value,
				// 	id = category.id,
				// 	found = _.find(testIds, function (num) {
				// 		return (num == id);
				// 	});
				//
				// return (typeof found !== 'undefined' && found !== null);
				return false;
			},

			isset(module_set) {
				// console.log('module_set',module_set,this.data_set[this.module_set]);
				// make sure current page is there
				if (!this.module_set in this.data_set) {
					return null;
				}
				// get the current page modules
				let $pageModules = this.data_set[this.module_set].modules;

				if (!module_set in $pageModules) {
					return null;
				}
				// console.log('isset(module_set)->$pageModules[module_set]',$pageModules[module_set]);
				return $pageModules[module_set];
			},
			save() {
				let _this = this;
				let data = {
					slug: _this.module_set,
					data_set: _this.data_set
				};

				axios.post(this.save_route_uri, data)
					.then(function (response) {
						if (response.data.success) {
							_this.data_set = response.data.pages;
							_this.changed_data_set = false;
						}
					})
					.catch(function () {

					});
			},
			categoryChooser() {
				let _this = this;
				let data = {};

				axios.post(this.categories_route_uri, data)
					.then(function (response) {
						if (response.data.success) {

							_this.categories = response.data.categories;
							// console.log('categoryChooser', '_this.categories', _this.categories);
						}
					})
					.catch(function () {

					});
			},

		},
		watch: {},
		computed: {}
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/modules/PagesManager.vue?020a90b0